export enum DmeToBeObtainedByEnum {
  Agency = 1,
  Other = 2
}

export const DmeToBeObtainedByOptions = [
{ id: 1, label: 'Agency' },
{ id: 2, label: 'Other' }
];
